import { ReactNode } from "react"
import {
  Block,
  Link,
  ParagraphMedium,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { links, MarketItemData } from "#/shared/constants"
import { MatsnetActionButton } from "#/ui/Button"
import MarketItemDetailsLayout from "#/ui/Market/MarketItemDetails/components/MarketItemDetailsLayout"

function TermsOfUseLink() {
  const [css] = useStyletron()

  return (
    <Link
      href={links.TERMS_OF_USE}
      target="_blank"
      className={css({
        color: "currentColor",
      })}
    >
      Terms of Use
    </Link>
  )
}

export default function MarketItemDetailsLayoutWithActionButton({
  itemData,
  submitButtonText,
  submitCallback,
  isSubmitButtonDisabled = false,
  isSubmitButtonLoading = false,
  isProcessing = false,
  hasError = false,
  errorMessage,
  imageTagText,
  children,
  submitButtonDataAttr,
  termsOfUseNote,
}: {
  itemData: MarketItemData
  submitButtonText: string
  submitCallback: () => Promise<void>
  isSubmitButtonDisabled?: boolean
  isSubmitButtonLoading?: boolean
  isProcessing?: boolean
  hasError?: boolean
  errorMessage?: string
  imageTagText?: string
  children?: ReactNode
  submitButtonDataAttr?: string
  termsOfUseNote?: (LinkComponent: ReactNode) => ReactNode
}) {
  const [css, theme] = useStyletron()

  if (!itemData) return null

  return (
    <MarketItemDetailsLayout
      pageTitle={itemData.mainTitle}
      image={itemData.fullImage}
      imageTagText={imageTagText}
    >
      {children}

      {termsOfUseNote && (
        <ParagraphSmall
          className={css({
            color: theme.colors.contentSecondary,
            textAlign: "center",
            marginTop: theme.sizing.scale800,
            marginBottom: theme.sizing.scale400,
          })}
        >
          {termsOfUseNote(<TermsOfUseLink />)}
        </ParagraphSmall>
      )}

      <MatsnetActionButton
        onClick={submitCallback}
        size="large"
        shape="pill"
        isDisabled={isSubmitButtonDisabled || isProcessing}
        isLoading={isSubmitButtonLoading || isProcessing}
        dataAttr={submitButtonDataAttr}
      >
        {submitButtonText}
      </MatsnetActionButton>

      {hasError && errorMessage && (
        <Block
          className={css({
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginTop: theme.sizing.scale600,
          })}
        >
          <ParagraphMedium color={theme.colors.red600}>
            {errorMessage}
          </ParagraphMedium>
        </Block>
      )}
    </MarketItemDetailsLayout>
  )
}
